<template>
  <div id="root-container">
    <!-- <link id="theme-css" rel="stylesheet" href="theme-light.css"> -->
    <router-view v-if="bootReady" />
    <load-animation v-else @ready="bootReady = true" />
    <line-selection v-if="isExe && linesVisible" @close="linesVisible = false" />
    <support-dialog ref="support" :visible.sync="supportVisible" :site="supportConfig.data.site || {}" @minimized="supportMinimized = supportState.minimized = $event" />
  </div>
</template>

<script>
import LoadAnimation from '@/views/startup/LoadAnimation.vue'
import LineSelection from '@/views/startup/LineSelection.vue'
import { isExe } from '@/utils/realmName'
import SupportDialog from '@/components/SupportDialog.vue'
import { systemConfig, loadSystemConfig } from '@/utils/systemConfig'
// import { DownOutlined } from '@ant-design/icons-vue';

export default {
  name: "app",
  provide() { return { openSupport: () => this.openSupport(), supportState: this.supportState } },
  data() {
    return {
      bootReady: !isExe(),
      supportVisible: false, supportMinimized: false, supportState: { opening: false, minimized: false }, supportRequest: 0, supportConfig: systemConfig,
      linesVisible: false,
      curSideIndex: 0,
      search: "",
      current: "hangqing",
      chartsIndex: "1"
    };
  },
  components: {
    LoadAnimation,
    LineSelection,
    SupportDialog,
    // DownOutlined
  },
  computed: { isExe },
  watch: { '$route.path'() { this.supportRequest++; if (this.$refs.support) this.$refs.support.dismiss() } },
  // mounted:function()
  // {
  //   const theme = localStorage.getItem('user-theme');
  //   if (theme) {
  //     document.getElementById('theme-css').href = `theme-${theme}.css`;
  //   } else {
  //               // 尝试匹配系统偏好
  //     const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  //     const initialTheme = prefersDark ? 'dark' : 'light';
  //     document.getElementById('theme-css').href = `theme-${initialTheme}.css`;
  //   }       
  // },      
  created() { this.$root.$on('select-lines', this.openLines) },
  beforeDestroy() { this.$root.$off('select-lines', this.openLines) },
  methods: {
    async openSupport() {
      if (this.supportState.opening) return false
      if (this.supportVisible || this.supportMinimized) {
        this.supportVisible = true
        if (this.$refs.support) this.$refs.support.resume()
        return true
      }
      const request = ++this.supportRequest
      this.supportState.opening = true
      try { await loadSystemConfig(); if (request !== this.supportRequest) return false; this.supportVisible = true; return true }
      catch (_) { this.$message.warning('客服配置加载失败，请重试'); return false }
      finally { this.supportState.opening = false }
    },
    openLines() { if (isExe()) this.linesVisible = true },
    onSearch(env) {
      console.log(env);
    }
  }
};
</script>

<style lang="scss">
@import "./assets/normal.css";


html,
body,
#root-container,
.ant-layout {
  height: 100%;
}


.ant-layout-sider {
  width: 60px !important;
  max-width: 60px !important;
  min-width: 60px !important;
}

.logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 64px;
}


.sidebar-menu-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 96px;
  cursor: pointer;
  color: var(--theme-text);
  &.active {
    div {
      color: #e88a07;
    }
    .iconfont {

      color: #e88a07;
    }
  }
}

.tool-bar .ant-btn-link {
  color: var(--theme-text);
}

.flex {
  display: flex;
}

.align-item__center {
  align-items: center;
}

.flex-1 {
  flex: 1;
}

.flex-2 {
  flex: 2;
}
</style>
